import React, { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import { getAnnouncement } from "@/lib/api";

export function AnnouncementBanner() {
  const [ann, setAnn] = useState({ message: "", enabled: false });

  useEffect(() => {
    let alive = true;
    const load = () => getAnnouncement().then((a) => { if (alive) setAnn(a); }).catch(() => {});
    load();
    const t = setInterval(load, 15000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!ann.enabled || !ann.message) return null;

  return (
    <div
      data-testid="announcement-banner"
      className="w-full bg-gradient-to-r from-amber-500 to-yellow-500 text-black"
    >
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-8 py-2 flex items-start sm:items-center gap-3 animate-announce-blink">
        <Megaphone className="h-5 w-5 shrink-0 mt-0.5 sm:mt-0" />
        <p className="flex-1 text-base sm:text-lg font-semibold leading-snug break-words" data-testid="announcement-text">
          {ann.message}
        </p>
      </div>
    </div>
  );
}
